module.exports = __webpack_public_path__ + "deb01e5a54d2de00f6cec7d0d7be1059.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-04-harrison-first-day-in-india/snippet.jpg
// module id = 562
// module chunks = 0